import { Tabs } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DriveIn from "./DriveIn/DriveIn";
import DriveInAuto from "./DriveInAuto/DriveInAuto";
import StdPalletRacking from "./StdPalletRacking/StdPalletRacking";
import StdPalletRackingAuto from "./StdPalletRackingAuto/StdPalletRackingAuto";
import NotificationButton from "../../Components/NotificationButton";

const ProfileProgram = () => {
  const { t } = useTranslation();
  const TAB_PALLET_RACKING = "Standard Pallet Racking";
  const TAB_PALLET_RACKING_AUTO = "Standard Pallet Racking Auto";
  const TAB_DRIVE_IN = "Drive-In Racking";
  const TAB_DRIVE_IN_AUTO = "Drive-In Auto Racking";
  const [activeKey, setActiveKey] = useState<string>(TAB_PALLET_RACKING);

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  const TAB_COMPONENTS: Record<string, React.ReactNode> = {
    [TAB_PALLET_RACKING]: <StdPalletRacking />,
    [TAB_PALLET_RACKING_AUTO]: <StdPalletRackingAuto />,
    [TAB_DRIVE_IN]: <DriveIn />,
    [TAB_DRIVE_IN_AUTO]: <DriveInAuto />,
  };

  return (
    <div className="page-content h-100 px-40 py-40">
      <div className="mb-3 d-flex flex-column gap-md-2 gap-0">
        <div className="d-flex flex-md-nowrap flex-wrap gap-sm-3 column-gap-2 justify-content-between align-items-center">
          <h2 className="text-black fs-36 fw-bolder page-title mb-0">
            {t("profileProgram.profileProgram")}
          </h2>
          <NotificationButton />
        </div>
      </div>
      <div>
        <div className="customHorizontalTabs bg-white overflow-hidden border-0 rounded-3 mb-3 d-inline-block mw-100">
          <Tabs
            activeKey={activeKey}
            onChange={onTabChange}
            items={[
              { key: TAB_PALLET_RACKING, label: "Standard Pallet Racking" },
              {
                key: TAB_PALLET_RACKING_AUTO,
                label: "Standard Pallet Racking Auto",
              },
              {
                key: TAB_DRIVE_IN,
                label: "Drive-In Racking",
              },
              { key: TAB_DRIVE_IN_AUTO, label: "Drive-In Auto Racking" },
            ]}
          />
        </div>
      </div>
      <div className="card page-table-card border-0 shadow rounded-4 flex-fill overflow-y-auto">
        {TAB_COMPONENTS[activeKey] || <div>Select a valid racking type</div>}
      </div>
    </div>
  );
};

export default ProfileProgram;
